import axiosInstance from ".";

export const getTest = () => {
  return axiosInstance.get("/testimonials");
};

export const addTest = (data) => {
  return axiosInstance.post("/testimonials", data);
};

export const udpateTest = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/testimonials/${id}`, payload);
};

export const deleteTest = (id) => {
  return axiosInstance.delete(`/testimonials/${id}`);
};

export const getTestById = (query) => {
    return axiosInstance.get(`/testimonials-by-id/${query?.queryKey?.[1]}`);
  };